const useCompraStore = defineStore("compra", () => {
  // state
  const compra = ref({
    id: null,
    monto: 0,
    total: 0,
    descripcion: "",
    model_id: null,
    model_type: null,
    usuario_id: null,
    pago_id: null,
    pago: null,
    usuario: null,
    con_envio: false,
    direccion: {},
    codigo_cupon: "",
    descuento_id: null,
    costo_envio: 0,
    descuento: {
      porcentaje: 0,
    },
  });

  const compras = ref([]);

  // mutations
  const setCompra = (comp) => {
    if (comp) compra.value = comp;
  };

  const setCompras = (ps) => {
    if (ps) compras.value = ps;
  };

  const clear = () => {
    compra.value = {
      id: null,
      monto: 0,
      total: 0,
      descripcion: "",
      model_id: null,
      model_type: null,
      usuario_id: null,
      pago_id: null,
      pago: null,
      usuario: null,
      con_envio: false,
      direccion: {},
      codigo_cupon: "",
      descuento_id: null,
      costo_envio: 0,
      descuento: {
        porcentaje: 0,
      },
    };
  };

  // actions

  const fetch = (compra_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/compras/${compra_id}/fetch-data`)
        .then(({ data }) => {
          setCompra(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const fetchData = (params) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/compras/fetch-data`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const comprarPlan = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/compras/comprar-plan`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const comprarLote = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/compras/comprar-lote`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const comprarPaginasDetal = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/compras/comprar-paginas`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const comprar = (datos) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/compras`, datos)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    compra,
    compras,
    // methods
    setCompra,
    setCompra,
    clear,
    fetch,
    fetchData,
    comprarPlan,
    comprarLote,
    comprarPaginasDetal,

    comprar,
  };
});

export default useCompraStore;
